import i18n from 'i18next'
import { registerLocale } from 'react-datepicker'
import { es, enGB, ca, gl, eu } from 'date-fns/locale'

// Register once to avoid missing locale warnings
registerLocale('es', es)
registerLocale('en', enGB)
registerLocale('ca', ca)
registerLocale('gl', gl)
registerLocale('eu', eu)

export function getDatePickerLocale(): string {
  const lang = i18n.language || 'es-ES'
  if (lang.startsWith('es')) return 'es'
  if (lang.startsWith('en')) return 'en'
  if (lang.startsWith('ca') || lang.startsWith('va')) return 'ca'
  if (lang.startsWith('ga') || lang.startsWith('gl')) return 'gl'
  if (lang.startsWith('eu')) return 'eu'
  return 'es'
}


